module.exports = __webpack_public_path__ + "assets/img/c1fa-sz.svg";